import React, { useEffect } from "react";
import { useTimer } from 'react-timer-hook';


const Timer = ({expirationDate})=> {

  const { seconds, minutes, hours, days, isRunning, restart } = useTimer({ expiryTimestamp: new Date(expirationDate) });

  useEffect(()=> restart(new Date(expirationDate)), [expirationDate]);

  return (
    <div>
      { isRunning && (
        <div>
          <div> <strong> {days < 10 ? '0' : ''}{days}:{hours < 10 ? '0' : ''}{hours}:{minutes < 10 ? '0' : ''}{minutes}:{seconds < 10 ? '0' : ''}{seconds} </strong> </div>
        </div>)}
    </div>
  )
}

export default Timer;

